import { Select } from "../Select";
import { IPeriodFilterViewProps } from "./PeriodFilter";

export const View = (props: IPeriodFilterViewProps) => {
  return (
    <div className="period-filter--input">
      <Select
        name="periodSelectFilter"
        label=""
        className="period-select--filter"
        placeholder="Select..."
        selectItems={props.options.map((op) => ({
          text: op.key,
          value: op.value as string,
        }))}
        onChange={(e) => props.onChange(e.target.value)}
        // value={props.activePeriodValue}
      />
    </div>
  );
};
